<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers /></el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
				
							<!-- Page Header -->
							<div class="page_header">
								Configure Training Types
							</div>
				
							<div class="page_main">
								<div class="training-type-page">
				
									<div class="tip-box">
										The following types can be selected when marking a user as having completed training.
										If you modify this list, you should also update the user help information for
										"How is this type of training performed?" on the "Mark Training Complete" page.
									</div>
				
				
									<div class="tip-box">
										<span class="tip-title">
											Allow Users to Sign Off Training Completion?
										</span>
										<span>
											- Specifies whether this type can be selected when users complete their assigned training.
										</span>
									</div>
				
				
									<div class="tip-box">
										<div>
											<span class="tip-title">
												Does This Indicate the Requirement Has Been Met?
											</span>
											<span>
												- Specifies whether selecting this training record type indicates that the user has met the training requirement.
											</span>
										</div>
				
										<ul class="tip-list">
											<li>
												A value of "Yes" indicates that completed training satisfies the training requirement
												(for example, the user completes classroom training or comprehension training).
											</li>
				
											<li>
												A value of "No" indicates that the training record should be closed,
												but the user should not be considered as having met the training requirement
												(for example, failed training verification or user leave).
											</li>
				
											<li>
												A value of "N/A" indicates that the training record should be closed,
												but should not be considered when determining whether the user has met the training requirement
												(for example, no review required - previous training applies).
											</li>
										</ul>
									</div>
				
				
									<div class="panel">
				
										<div class="panel-header">
											<h2 class="panel-title">
												Training Types
											</h2>
										</div>
				
				
										<el-table v-loading="tableLoading" :data="tableData" border stripe
											header-cell-class-name="table-header-cell"
											cell-class-name="table-body-cell"
											class="training-table">
				
				
											<!-- Operation -->
											<el-table-column label="Actions" width="80" fixed="left" align="center">
												<template slot-scope="scope">
													<el-button type="primary" size="mini"
														@click="handleEdit(scope.row)">
														Edit
													</el-button>
												</template>
											</el-table-column>
				
				
											<el-table-column prop="title"
												label="Training Type Name"
												min-width="260"
												sortable />
				
				
											<el-table-column prop=""
												label="Allow Users to Sign Off Training Completion?"
												min-width="280"
												sortable>
				
												<template slot-scope="scope">
													<div v-if="scope.row.allow_sign == 1">Yes</div>
													<div v-if="scope.row.allow_sign == 2">No</div>
												</template>
				
											</el-table-column>
				
				
											<el-table-column prop=""
												label="Does This Indicate the Requirement Has Been Met?"
												min-width="260"
												sortable>
				
												<template slot-scope="scope">
													<div v-if="scope.row.is_meet == 1">Yes</div>
													<div v-if="scope.row.is_meet == 2">No</div>
													<div v-if="scope.row.is_meet == 3">N/A</div>
												</template>
				
											</el-table-column>
				
				
											<!-- Operation -->
											<el-table-column label="Actions" width="80" align="center">
				
												<template slot-scope="scope">
													<el-button type="danger" size="mini"
														@click="handleDelete(scope.row)">
														Delete
													</el-button>
												</template>
				
											</el-table-column>
				
				
										</el-table>
				
				
										<div class="panel-footer">
				
											<el-button type="primary" @click="handleAdd">
												Add Training Type
											</el-button>
				
											<el-button type="primary" @click="handleClose">
												Cancel
											</el-button>
				
										</div>
				
									</div>
				
								</div>
							</div>
				
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { trainLeixingList, trainLeixingDel } from '@/api/trainManage/configTrain/trainType/index';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
export default {
	components: {
		headers,
		slider,
	},
	data() {
		return {
			isLoading: true,
			tableLoading: false,
			query: {
				title: ''
			},
			tableData: [],
		};
	},
	created() {
		let that = this;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
		that.getTableData();
	},
	watch: {
		//
	},
	methods: {
		//获取表格数据
		getTableData() {
			let that = this;
			that.tableLoading = true;
			trainLeixingList(that.query).then(res => {
				that.tableLoading = false;
				if(res.code == 200) {
					that.tableData = res.data;
				}
			});
		},
		// 添加
		handleAdd() {
			let that = this;
			that.goUrl("/TrainControl/type-add-edit");
		},
		// 编辑
		handleEdit(row) {
			let that = this;
			that.$router.push({ path: '/TrainControl/type-add-edit', query: { oid: row.id } });
		},
		// 删除
		handleDelete(row) {
			let that = this;
			that.$confirm('Are you sure you want to delete this training type?', "Confirmation", {
				type: "warning",
			}).then(() =>{
				that.$toast.loading({ duration: 0, forbidClick: true });
				trainLeixingDel({ id: row.id }).then(res => {
					if(res.code == 200) {
						that.$toast.clear();
						that.$message.success('Operation successful');
						setTimeout(() => {
							that.getTableData();
						}, 800);
					}
				});
			}).catch(() =>{});
		},
		handleClose() {
			let that = this;
			that.$router.back();
		},
		//跳转页面
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
	}
}
</script>

<style lang="less" scoped>
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}

.training-type-page {
  padding: 16px 12px 30px;
  background: #f5f6f7;
  min-height: 100vh;
  box-sizing: border-box;
}

.tip-box {
  background: #f6efdf;
  border-radius: 4px;
  color: #333;
  padding: 14px 16px;
  margin-bottom: 14px;
  font-size: 14px;
  line-height: 24px;
}

.tip-title {
  font-weight: 700;
}

.tip-list {
  margin: 8px 0 0 18px;
  padding: 0;
}

.tip-list li {
  line-height: 26px;
}

.panel {
  background: #fff;
  border: 1px solid #dcdfe6;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px 8px;
  border-bottom: 1px solid #dcdfe6;
}

.panel-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #222;
}

.panel-tools {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-input {
  width: 220px;
}

.collapse-btn {
  width: 28px;
  height: 28px;
  padding: 0;
}

.training-table {
  width: 100%;
}

::v-deep .table-header-cell {
  background: #fff !important;
  color: #222;
  font-weight: 700;
  font-size: 16px;
}

::v-deep .table-body-cell {
  color: #222;
  font-size: 15px;
}

::v-deep .el-table td,
::v-deep .el-table th {
  padding: 14px 0;
}

::v-deep .el-table--border th,
::v-deep .el-table--border td {
  border-right: 1px solid #dcdfe6;
}

::v-deep .el-button--mini {
  padding: 7px 12px;
  font-size: 14px;
}

.panel-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 24px 0 28px;
}

::v-deep .btn span {
  text-decoration: underline;
}
</style>

